module.exports = __webpack_public_path__ + "static/media/noaccessDark.7b663c74.png";